import Cookies from 'js-cookie';

export const allDevicesIsInternationalRegistry = () => {
    if ((Cookies.get('zCountry') != 'US') && ($("#registry-bag").length > 0)) {
        $("#shopCart-proceed-checkout-top, #shopCart-proceed-checkout-bottom").addClass('disabled').css('cursor', 'not-allowed');
        $("#error-message-intl-registry").show();
        $(".cart-shopper-actions").hide();
    }
};
